import { resolvePickerEmojis } from "./reactions";

// A dependency-free emoji picker grid. Curated, common-first emojis rendered as
// native unicode. The emoji set is resolved per-network (SAD-configurable) with
// a built-in default; the canonical default list lives in reactions.ts so the
// activitystream and chat pickers stay in sync.
type Props = {
  onSelect: (emoji: string) => void;
};

export default function EmojiGrid({ onSelect }: Props) {
  const emojis = resolvePickerEmojis();

  return (
    <div className="reactions__emoji_grid max-h-60 w-72 overflow-y-auto rounded-lg border border-gray-200 bg-white p-2 shadow-lg">
      <div className="grid grid-cols-8 gap-0.5">
        {emojis.map((emoji, index) => (
          <button
            key={`${emoji}-${index}`}
            type="button"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded text-lg leading-none hover:bg-gray-100"
            onClick={() => onSelect(emoji)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}
